import { useNavigate } from 'react-router-dom';
import { PedidoAtualizar, PedidoCadastrar } from '../routes/RoutesNames';
import PedidoController from '../controllers/PedidoController';
import { useEffect, useState, useRef } from 'react';
import { PedidoLista } from '../controllers/Types';
import { Column } from '../pages/Components/Table/Types';
import { formatDate, formatarData } from '../shared/utils/helpers/date';
import { formatCurrency } from '../shared/utils/helpers/numbers';
import { PedidoList } from '../shared/types/Pedido';
import { ButtonMenu } from '../shared/components/ButtonMenu';
import { toast } from 'react-toastify';
import Status from '../pages/Components/Status/Index';
import { openBase64InNewTab } from '../shared/utils/helpers/base64';
import * as Icon from '@mui/icons-material/';
import Api from '../services/Api';
import { OPTIONS_FINALITY } from '../shared/utils/const/FinalityOptions';
import DevolucaoController from '../controllers/DevolucaoController';

const getStatusColor = (s: string) => ({
  'finalizado': '#4caf50',
  'pago': '#4caf50',
  'aberto': '#42a5f5',
  'cancelado': '#999',
  'a criar': '#ef5350'
})[s.toLowerCase()] || '#999'

const ENABLE_GERAR_NF = ['ABERTO'];

export const usePedidoBuscar = () => {
  const navigate = useNavigate();
  // Pedido cuja devolucao esta aberta no modal. null = modal fechado.
  const [devolucaoVendaId, setDevolucaoVendaId] = useState<number | null>(null);
  const tableColumns: Column[] = [
    {
      id: 'vnd_id', label: 'Número', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'vnd_status', label: 'Status', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'vnd_finalidade', label: 'Finalidade', minWidth: 0, align: 'center', maxWidth: undefined },
    // Sem esta coluna a devolucao aparece na grade igual a um pedido - mesmo cliente,
    // mesmo valor, mesmo status. O operador veria "pedidos" que nunca vendeu nada.
    { id: 'especie', label: 'Espécie', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'nome_cliente', label: 'Cliente', minWidth: 0, maxWidth: undefined },
    { id: 'nome_vendedor', label: 'Vendedor', minWidth: 0, maxWidth: undefined },
    { id: 'vnd_total_geral', label: 'Total', minWidth: 0, maxWidth: undefined },
    { id: 'vnd_datainc', label: 'Data', minWidth: 0, maxWidth: undefined },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right', maxWidth: undefined },
  ];

  const fields = [
    { name: 'vend_id', type: 'number', label: 'Número', col: 2 },
    {
      name: 'vend_status',
      type: 'select',
      options: [
        {
          value: 'Aberto',
          label: 'Aberto',
        },
        {
          value: 'Faturado',
          label: 'Faturado',
        },
        {
          value: 'Finalizado',
          label: 'Finalizado',
        },
        {
          value: 'Cancelado',
          label: 'Cancelado',
        },
        {
          value: 'Todos',
          label: 'Todos',
        },
      ],
      label: 'Status',
      col: 2,
    },
    {
      name: 'finalidade',
      type: 'select',
      options: OPTIONS_FINALITY,
      label: 'Finalidade',
      col: 2,
    },
    { name: 'cliente', type: 'text', label: 'Cliente', col: 2 },
    { name: 'vendedor', type: 'text', label: 'Vendedor', col: 2 },
    { name: 'total', type: 'money', label: 'Valor', col: 2 },
    { name: 'data_inicio', type: 'date', label: 'Data Início', col: 2 },
    { name: 'data_fim', type: 'date', label: 'Data Fim', col: 2 },
    { type: 'submit', icon: <Icon.Search style={{ fontSize: '28px' }} /> },
  ];
  
  const [loading, setLoading] = useState(false);
  const [pedidosLista, setPedidoLista] = useState<PedidoLista[]>([]);
  const handleNavigation = async (): Promise<void> => {
    navigate(PedidoCadastrar);
  };

  const onSubmit = async () => {
    await handleList();
  };

  const handleGerarNF = async (vnd_id: number) => {
    setLoading(true);
    const response = await PedidoController.PedidoGerarNotaFiscal(vnd_id);
    setLoading(false);

    if (response.StatusCode && response.StatusCode >= 300) {
      toast(response?.Data?.ErroDetalhado, { type: 'error' });
      return;
    }

    toast('Nota Fiscal gerada com sucesso', { type: 'success' });
    await handleList();
  }

  const handleEditItem = (item: PedidoList, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      //window.open(`${PedidoAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } }}`, "_blank");  
      navigate(PedidoAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(PedidoAtualizar.replace(':id', item.vnd_id.toString()));
    }
  }

  const handleClonarItem = (item: PedidoList) => {
    const clonar = 'S';
    navigate(PedidoAtualizar.replace(':id', item.vnd_id.toString()), { state: { clonar } });
  }

  const handleCancelarItem = async (vnd_id: number) => {
    const Response = await PedidoController.PedidoCancelar(vnd_id);
    if (Response.StatusCode === 204) {
      toast.info('Pedido cancelado!', { type: 'warning' });
    } else {
      toast(Response.ErroDetalhado, { type: 'error' })
    }
    handleList();
  }

  /**
   * Cancelar uma DEVOLUCAO nao e a mesma coisa que cancelar um pedido.
   *
   * A PROC_VENDA_CANCELAR nao sabe estornar estoque, reabrir os titulos que a devolucao
   * cancelou nem desfazer os que ela gerou. Chamar ela aqui deixaria o financeiro e o
   * estoque num estado que ninguem consegue explicar depois.
   */
  /**
   * [25/09] A nota fiscal DA DEVOLUÇÃO.
   *
   * Ação própria, e não o "Gerar Nota Fiscal" do pedido: aquele emite nota de SAÍDA com os
   * itens, e numa devolução os itens estão VOLTANDO. Reaproveitar a mesma ação inverteria
   * o sentido da operação — é o que o comentário do menu já dizia desde 22/09.
   *
   * A recusa vem da procedure em português e é repassada sem tradução. A mais comum, hoje,
   * é o CFOP sem aval do contador — e a mensagem diz qual CFOP falta, porque "não pode
   * emitir" sozinho não diz a quem recorrer.
   */
  const handleGerarNotaDevolucao = async (vnd_id: number) => {
    setLoading(true);
    const Response = await DevolucaoController.GerarNota(vnd_id);
    setLoading(false);

    if (Response.StatusCode === 200) {
      toast(`Nota fiscal da devolução gerada (nº interno ${Response.Data?.nfe_id ?? '-'}).`,
            { type: 'success' });
      // A transmissão é outra tela: dizer isso evita a espera por algo que não vai
      // acontecer sozinho.
      toast('A transmissão para a SEFAZ é feita na tela de Notas Fiscais.',
            { type: 'info', autoClose: 10000 });
    } else {
      toast(Response.ErroDetalhado, { type: 'error', autoClose: 15000 });
    }
    handleList();
  }

  const handleCancelarDevolucao = async (vnd_id: number) => {
    const Response = await DevolucaoController.Cancelar(vnd_id);

    if (Response.StatusCode === 200) {
      const precisaBoleto = Response.Data?.precisa_reprocessar_boleto;
      toast('Devolução cancelada.', { type: 'warning' });

      // Baixa de boleto no banco nao volta. Se titulos foram reabertos, os boletos
      // precisam ser gerados de novo - e o operador tem de saber disso AGORA.
      if (precisaBoleto === true || precisaBoleto === 1) {
        toast(
          'Os títulos foram reabertos, mas os boletos baixados no banco não voltam: é preciso reprocessar os boletos deste pedido.',
          { type: 'warning', autoClose: 15000 }
        );
      }

      /**
       * [25/09] O dinheiro que a devolução tinha devolvido ao cliente também voltou atrás,
       * e isso precisa ser dito: quem cancela costuma ser quem já prometeu o crédito ao
       * cliente, e descobrir depois pelo extrato é tarde.
       *
       * Os dois valores vêm da procedure (script 112). Só avisa quando houve estorno -
       * aviso que aparece sempre vira aviso que ninguém lê.
       */
      const creditoEstornado = Number(Response.Data?.credito_estornado ?? 0);

      if (creditoEstornado > 0.004) {
        toast(
          `O crédito de ${formatCurrency(creditoEstornado)} gerado por esta devolução foi estornado da conta corrente do cliente.`,
          { type: 'warning', autoClose: 15000 }
        );
      }

      /**
       * [28/09] A nota fiscal da devolução também é cancelada (script 126).
       *
       * Dito porque o operador acabou de gerar essa nota e pode estar esperando por ela.
       * O número aparece para conferência na tela de Notas Fiscais, onde ela continua
       * listada como Cancelada — não some.
       */
      const notaCancelada = Response.Data?.nota_cancelada;

      if (notaCancelada === true || notaCancelada === 1) {
        toast(
          `A nota fiscal ${Response.Data?.nota_fiscal ?? ''} desta devolução foi cancelada junto. Ela não havia sido transmitida.`,
          { type: 'warning', autoClose: 15000 }
        );
      }

      const pagamentoCancelado = Response.Data?.pagamento_cancelado;

      if (pagamentoCancelado === true || pagamentoCancelado === 1) {
        toast(
          'O contas a pagar gerado por esta devolução foi cancelado.',
          { type: 'warning', autoClose: 15000 }
        );
      }
    } else {
      toast(Response.ErroDetalhado, { type: 'error', autoClose: 10000 });
    }
    handleList();
  }

  const handleList = async () => {
    setLoading(true);
    const DataRows: any = [];
    // @ts-ignore - .
    const result = await PedidoController.PedidoLista(formRef?.current?.values);

    if (result.StatusCode === 200) {
      result.Data.map((item: any) => {
        const isLocacao = String(item.vnd_finalidade ?? '').toLowerCase().includes('loca');
        const isDevolucao = item.vnd_especie_doc === 'D';

        /* DEVOLUCAO NAO E PEDIDO, e nenhuma das acoes de pedido serve para ela:
             - Gerar Nota Fiscal emitiria uma nota de SAIDA com os itens que estao
               VOLTANDO. A nota de devolucao e outra coisa (finNFe 4, tpNF 0, refNFe) -
               por isso ela tem acao PROPRIA aqui, "Gerar nota de devolucao", desde 25/09;
             - Editar abriria a devolucao na tela de pedido, e salvar rodaria a
               PROC_VENDA_GRAVAR, que nao conhece o vndprod_id_origem e regravaria os
               itens por produto - perdendo o vinculo com as linhas de origem;
             - Copiar clonaria uma devolucao como pedido novo;
             - Cancelar chamaria a proc errada (ver handleCancelarDevolucao).
           Por isso a devolucao oferece apenas as DUAS acoes que fazem sentido para ela:
           a nota de devolucao e o proprio cancelamento. */
        const menuItems = isDevolucao ? [
          {
            // Sempre habilitado, pelo mesmo motivo do "Gerar Devolução": quem decide é a
            // procedure, e ela devolve o MOTIVO. Item cinza não explica nada.
            onClick: () => handleGerarNotaDevolucao(item.vnd_id),
            menu: 'Gerar nota de devolução',
          },
          {
            onClick: () => handleCancelarDevolucao(item.vnd_id),
            menu: 'Cancelar devolução',
          },
        ] : [
          // Locação não emite NF: opção só aparece para as demais finalidades.
          ...(!isLocacao ? [{
            onClick: () => handleGerarNF(item.vnd_id),
            menu: 'Gerar Nota Fiscal',
            disabled: !ENABLE_GERAR_NF.includes(item.vnd_status),
          }] : []),
          {
            onClick: () => handleEditItem(item),
            menu: 'Editar',
            disabled: !ENABLE_GERAR_NF.includes(item.vnd_status),
          },
          { onClick: () => handleClonarItem(item), menu: 'Copiar' },
          {
            onClick: () => handleCancelarItem(item.vnd_id),
            menu: 'Cancelar',
          },
          // Sempre habilitado, de proposito: quem decide se o pedido pode ser devolvido e
          // a API, e ela devolve o MOTIVO quando nao pode. Item cinza nao explica nada;
          // o modal abre e diz "este pedido ja tem parcela paga".
          {
            onClick: () => setDevolucaoVendaId(item.vnd_id),
            menu: 'Gerar Devolução',
          },
        ];
        DataRows.push({
          BtnMenu: (
            <ButtonMenu items={menuItems} />
          ),
          ...item,
          vnd_status: item?.vnd_status && (
            <Status
              text={item.vnd_status || ''}
              color={getStatusColor(item.vnd_status || '')}
            />
          ),
          especie: item.vnd_especie_doc === 'D'
            ? <Status text="Devolução" color="#ef5350" />
            : <Status text="Venda" color="#42a5f5" />,
          vnd_datainc: formatDate(item.vnd_datainc),
          vnd_total_geral: formatCurrency(item.vnd_total_geral, 2, 2),
        });
      });
    }

    setPedidoLista(DataRows);
    setLoading(false);
  };

  const downloadRelatorio = async () => {
    // @ts-ignore - .
    const v = formRef?.current?.values;
    try {
      setLoadingRelatorio(true);
      const response = await Api.post(`api/relatorio/Vendas`, {
        dataInicio: v.data_inicio,
        dataFim: v.data_fim,
      });
      openBase64InNewTab(response.data.base64, 'my-file', 'application/pdf');
      setLoadingRelatorio(false);
    } catch (e) {
      console.error(e);
      toast('Erro ao baixar relatório', { type: 'error' });
      setLoadingRelatorio(false);
    }
  }

  const formRef = useRef(null);
  const [loadingRelatorio, setLoadingRelatorio] = useState(false);
  // [29/09] Relatório de Locação - card [RELATORIOS]. Loading próprio: os dois
  // relatórios podem ser pedidos um atrás do outro, e um spinner compartilhado
  // acenderia o botão errado.
  const [modalLocacaoAberto, setModalLocacaoAberto] = useState(false);
  const [loadingLocacao, setLoadingLocacao] = useState(false);
  const [modalServicosAberto, setModalServicosAberto] = useState(false);
  const [loadingServicos, setLoadingServicos] = useState(false);
  const [modalPecasAberto, setModalPecasAberto] = useState(false);
  const [loadingPecas, setLoadingPecas] = useState(false);
  const [periodoSugerido, setPeriodoSugerido] = useState({ inicio: '', fim: '' });

  /* O botão abre o modal com as datas que a tela já tem. O período é o único filtro
     deste relatório - o card é explícito: "Não deverá existir filtro adicional". */
  const abrirRelatorioLocacao = () => {
    // @ts-ignore - o formRef do FormBuilder não é tipado neste hook.
    const v = formRef?.current?.values;
    setPeriodoSugerido({ inicio: v?.data_inicio ?? '', fim: v?.data_fim ?? '' });
    setModalLocacaoAberto(true);
  };

  const gerarRelatorioLocacao = async (parametros: any) => {
    try {
      setLoadingLocacao(true);

      const response = await Api.post(`api/relatorio/Locacao`, {
        dataInicio: parametros.dataInicio,
        dataFim: parametros.dataFim,
      });

      openBase64InNewTab(response.data.base64, 'my-file', 'application/pdf');
      setModalLocacaoAberto(false);
    } catch (e: any) {
      console.error(e);
      const erro = e?.response?.data;
      toast(erro?.ErroDetalhado || erro?.Erro || 'Erro ao baixar relatório de locação',
            { type: 'error', autoClose: 10000 });
    } finally {
      setLoadingLocacao(false);
    }
  };

  /* Serviços: mesmo desenho do de Locação. O período é o único filtro - o card é
     explícito nos dois: "Não deverá existir filtro adicional". */
  const abrirRelatorioServicos = () => {
    // @ts-ignore - o formRef do FormBuilder não é tipado neste hook.
    const v = formRef?.current?.values;
    setPeriodoSugerido({ inicio: v?.data_inicio ?? '', fim: v?.data_fim ?? '' });
    setModalServicosAberto(true);
  };

  const gerarRelatorioServicos = async (parametros: any) => {
    try {
      setLoadingServicos(true);

      const response = await Api.post(`api/relatorio/Servicos`, {
        dataInicio: parametros.dataInicio,
        dataFim: parametros.dataFim,
      });

      openBase64InNewTab(response.data.base64, 'my-file', 'application/pdf');
      setModalServicosAberto(false);
    } catch (e: any) {
      console.error(e);
      const erro = e?.response?.data;
      toast(erro?.ErroDetalhado || erro?.Erro || 'Erro ao baixar relatório de serviços',
            { type: 'error', autoClose: 10000 });
    } finally {
      setLoadingServicos(false);
    }
  };

  /* Peças Vendidas: a peça nasce na Ordem de Serviço, mas o relatório sai aqui, na tela
     de Vendas - foi o que o card pediu, e é coerente: ele só mostra peça que virou venda
     faturada. */
  const abrirRelatorioPecas = () => {
    // @ts-ignore - o formRef do FormBuilder não é tipado neste hook.
    const v = formRef?.current?.values;
    setPeriodoSugerido({ inicio: v?.data_inicio ?? '', fim: v?.data_fim ?? '' });
    setModalPecasAberto(true);
  };

  const gerarRelatorioPecas = async (parametros: any) => {
    try {
      setLoadingPecas(true);

      const response = await Api.post(`api/relatorio/PecasVendidas`, {
        dataInicio: parametros.dataInicio,
        dataFim: parametros.dataFim,
      });

      openBase64InNewTab(response.data.base64, 'my-file', 'application/pdf');
      setModalPecasAberto(false);
    } catch (e: any) {
      console.error(e);
      const erro = e?.response?.data;
      toast(erro?.ErroDetalhado || erro?.Erro || 'Erro ao baixar relatório de peças vendidas',
            { type: 'error', autoClose: 10000 });
    } finally {
      setLoadingPecas(false);
    }
  };

  const initialValues = {
    vnd_id: null,
    vend_status: 'Aberto',
    finalidade: 'Todos',
    cliente: '',
    vendedor: '',
    total: null,
    data_inicio: formatarData(new Date((new Date()).setMonth(new Date().getMonth() - 1))),
    data_fim: formatarData(new Date()),
  }

  useEffect(() => {
    handleList();
  }, []);

  return {
    onSubmit,
    initialValues,
    fields,
    handleEditItem,
    handleNavigation,
    loading,
    pedidosLista,
    tableColumns,
    formRef,
    downloadRelatorio,
    loadingRelatorio,
    abrirRelatorioLocacao,
    gerarRelatorioLocacao,
    modalLocacaoAberto,
    fecharModalLocacao: () => setModalLocacaoAberto(false),
    loadingLocacao,
    abrirRelatorioServicos,
    gerarRelatorioServicos,
    modalServicosAberto,
    fecharModalServicos: () => setModalServicosAberto(false),
    loadingServicos,
    abrirRelatorioPecas,
    gerarRelatorioPecas,
    modalPecasAberto,
    fecharModalPecas: () => setModalPecasAberto(false),
    loadingPecas,
    periodoSugerido,
    devolucaoVendaId,
    setDevolucaoVendaId,
    handleList,
  };
};

export default usePedidoBuscar;
